import React, { type ReactNode } from 'react';
import { createPortal } from 'react-dom';

/** Column-header tooltip. Rendered through a portal *below* the header so
 *  the table's overflow and the search bar can never clip it. */
export function HeaderTip({ label, tip }: { label: ReactNode; tip: string }) {
  const [open, setOpen] = React.useState(false);
  const [pos, setPos] = React.useState({ x: 0, y: 0 });
  const ref = React.useRef<HTMLSpanElement>(null);

  function place() {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    setPos({ x: r.left + r.width / 2, y: r.bottom + 8 });
  }

  return (
    <span
      ref={ref}
      onMouseEnter={() => {
        place();
        setOpen(true);
      }}
      onMouseLeave={() => setOpen(false)}
      style={{ cursor: 'help', borderBottom: '1px dotted var(--text-3)' }}
    >
      {label}
      {open
        ? createPortal(
            <div
              role="tooltip"
              style={{
                position: 'fixed', left: pos.x, top: pos.y, transform: 'translateX(-50%)', zIndex: 3000,
                background: 'var(--brand-ink)', color: '#fff', fontSize: 11.5, fontWeight: 600,
                padding: '6px 9px', borderRadius: 7, whiteSpace: 'nowrap', boxShadow: 'var(--shadow-2)',
                pointerEvents: 'none', animation: 'siteCardIn .12s ease both', textTransform: 'none', letterSpacing: 0,
              }}
            >
              {tip}
            </div>,
            document.body,
          )
        : null}
    </span>
  );
}
